"use client";
import React,{ useState } from 'react';
import { AppContext } from '@context/AppContext';

class AppBottom extends React.Component { 
	static contextType = AppContext;
	declare context: React.ContextType<typeof AppContext>;

	is_whatsIt = (namekey_val: string) => {
		const { context_data, dispatchContext } = this.context;

		dispatchContext({ type: "STATE", state: "enabled", namekey: namekey_val });
	}

	render() {
		const span_css = "block mt-[3px] clear-both text-[15px] text-[#3472A9]";
		const span_css1 = "block mt-[3px] clear-both text-[12px] text-[#3472A9]";
		
		return (
			<div className="m-2 clear-both w-full text-center">
				<span className={span_css}>Natural-language addressing for everything in your life!</span>
				<span className={span_css}>No more complicated web links - just simple, natural language.</span>
				<span className={span_css}>Hierarchical blockchain email & simple contracts & AI assistance.</span>
				<a href="#" className={`${span_css} underline font-bold`} onClick={() => this.is_whatsIt("What is Msgdsk.com?")} title="Click the link below and then button Find msg.">What is Msgdesk.com?</a>
				<span className={span_css1}>© <a className={`underline`} href="iegyc7j70k27">Nazarov's project</a> (Android app on Jul'25)</span>
			</div>
		);
	}
}

export default AppBottom;